var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1127 28.8275L2.40416 19.119C2.18089 18.8957 2.18089 18.5338 2.40416 18.3106L14.8883 5.82646C14.9884 5.72637 15.1231 5.66862 15.2617 5.66093L21.752 5.30677C21.9137 5.29907 22.0715 5.35681 22.187 5.4723L25.7556 9.04083C25.871 9.15632 25.9288 9.31415 25.9211 9.47583L25.5669 15.9662C25.5592 16.1048 25.5015 16.2395 25.4014 16.3396L12.9211 28.8198C12.6979 29.0508 12.336 29.0508 12.1127 28.8275ZM3.62447 18.7148L12.5169 27.6072L24.4352 15.689L24.7624 9.67216L21.5557 6.46548L15.5388 6.79269L3.62062 18.7109L3.62447 18.7148Z",
    fill: "#BA1E24",
    stroke: "#BA1E24",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3934 10.8386C20.813 11.2582 20.8169 11.9473 20.3934 12.3708C19.97 12.7942 19.2848 12.7942 18.8613 12.3708C18.4379 11.9473 18.4379 11.2621 18.8613 10.8386C19.2848 10.4152 19.9738 10.419 20.3934 10.8386ZM21.2057 10.0264C20.3357 9.15637 18.9268 9.15637 18.0568 10.0264C17.1868 10.8964 17.1868 12.3053 18.0568 13.1753C18.9268 14.0453 20.3357 14.0453 21.2057 13.1753C22.0718 12.3092 22.0757 10.8964 21.2057 10.0264Z",
    fill: "#BA1E24",
    stroke: "#BA1E24",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20529 20.3008C7.98201 20.0775 7.98201 19.7156 8.20529 19.4923L14.2221 13.4755C14.4454 13.2522 14.8073 13.2522 15.0305 13.4755C15.2538 13.6988 15.2538 14.0606 15.0305 14.2839L9.01369 20.3008C8.79042 20.524 8.42856 20.524 8.20529 20.3008Z",
    fill: "#BA1E24",
    stroke: "#BA1E24",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4567 20.5394C14.2335 20.3162 14.2335 19.9543 14.4567 19.731L17.4632 16.7245C17.6865 16.5012 18.0484 16.5012 18.2716 16.7245C18.4949 16.9478 18.4949 17.3096 18.2716 17.5329L15.2651 20.5394C15.0457 20.7588 14.68 20.7627 14.4567 20.5394Z",
    fill: "#BA1E24",
    stroke: "#BA1E24",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.308a943a97fd8b8b6fe3c7c49544683a.svg";
export { ForwardRef as ReactComponent };